import { useQuery } from '@tanstack/react-query'
import { monthSections } from './listSections'
import { currentOf } from './monthParam'
import { localToday } from './recurringRules'
import { monthQueryOptions } from './useRecurring'

/**
 * The Recurring nav badge's number — D11, controller Ruling 50.
 *
 * `monthSections(<current month>).overdue.count`: the SAME classifier and the
 * same figure as the Overdue tile, so the badge and the tile cannot disagree.
 * That makes it outflows only (D6 — an inflow is income, never "due") and P3's
 * client rule (local today, this month's floor), never `/summary`'s
 * `overdue_count`, which is UTC-dated and stream-level (S17).
 *
 * The CURRENT month by the user's local date, never the month strip's
 * selection: the badge says what is overdue now, whatever month the screen is
 * showing. It reads the calendar query the list reads for that month (one cache
 * entry, `monthQueryOptions`), so a mark-paid's optimistic flip and its settle
 * move the badge in the same render as the tile.
 *
 * `undefined` while that month is unknown — loading or failed. The badge is
 * garnish on a link that works without it, so an unknown count shows nothing
 * rather than a guess. Hiding a 0 is the nav's call (`navBadge`), not this one:
 * 0 is a real answer here, and `recurring_viewed` reports it.
 */
export function useRecurringOverdueCount(): number | undefined {
  return useCurrentOverdue().count
}

/**
 * The same read, plus whether it FAILED — which `undefined` alone cannot say.
 * `recurring_viewed` waits for the count, and must not wait on a read that has
 * already given up.
 */
export function useCurrentOverdue(): { count: number | undefined; failed: boolean } {
  const today = localToday()
  const { data, isError } = useQuery(monthQueryOptions(currentOf(today)))
  return { count: data === undefined ? undefined : monthSections(data, today).overdue.count, failed: isError }
}
